import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import './styles.css';

hydrateRoot(
  document.getElementById('root'),
  <StrictMode>
    <BrowserRouter>
      <App
      initialSurah={window.__JUZAMMA_DATA__?.surah ?? null}
      initialQuiz={window.__JUZAMMA_DATA__?.quiz ?? null}
    />
    </BrowserRouter>
  </StrictMode>,
);
